import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  bindToDOM(dataAttribute: string, appVersion: string, elementToBind = 'body'): void {
    this.document[elementToBind].setAttribute(dataAttribute, appVersion);
  }
}
